module.exports = __webpack_public_path__ + "static/media/balloon-envelope.95ab3f49.svg";